import { useTranslations } from 'next-intl';
import { useState } from 'react';

import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCollapseBase } from '@/fo/ui/kit/collapse/base';
import { useMediaQuery } from '@/fo/ui/mod/media/query';
import { Product, UiProductTileMini } from '@/fo/ui/product/tile/mini';

import { ProgramType, GroupedProduct } from '../../types';
import { Grouped } from '../Grouped/Grouped';

import { styles } from './Program.styles';

export interface UiProductSectionCareProgramsProps {
  program: ProgramType;
  renderGrouped?: (product: GroupedProduct) => React.ReactNode;
  renderProduct?: (product: Product, index: number) => React.ReactNode;
}

export function Program({
  program,
  renderGrouped = defaultRenderGroupedProduct,
  renderProduct = defaultRenderProduct,
  ...props
}: UiProductSectionCareProgramsProps) {
  const t = useTranslations();
  const isDesktop = useMediaQuery('md');

  const [isCollapse, setIsCollapse] = useState(true);

  const slots = styles();

  const { products, grouped } = program;

  const onCollapse = () => {
    if (!isDesktop) {
      setIsCollapse((s) => !s);
    } else {
      setIsCollapse(true);
    }
  };

  return (
    <div
      className={slots.base()}
      {...props}
    >
      {renderGrouped(grouped)}
      <div>
        <UiKitButtonBase
          className={slots.collapseButton()}
          onClick={onCollapse}
          color="ghost"
        >
          {t('CareProgramsProductComposition')}
          <ChevronIcon
            className={slots.arrow({
              className: isCollapse ? 'rotate-90' : '-rotate-90'
            })}
          />
        </UiKitButtonBase>
        <UiKitCollapseBase
          className="md:!max-h-max"
          collapse={isCollapse}
          onClick={onCollapse}
        >
          <div className={slots.products()}>{products.map(renderProduct)}</div>
        </UiKitCollapseBase>
      </div>
    </div>
  );
}

const defaultRenderGroupedProduct = (product: GroupedProduct) => {
  return <Grouped product={product} />;
};

const defaultRenderProduct = (product: Product, index: number) => {
  return (
    <UiProductTileMini
      key={`${product.id}-${index}`}
      product={product}
    />
  );
};
